module.exports = __webpack_public_path__ + "Pe-icon-7-stroke.71394c0c7ad6c1e7d5c7.eot";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/newtheme/fonts/Pe-icon-7-stroke.eot?d7yf1v
// module id = 484
// module chunks = 2